import React from 'react';

const PriceCell = ({
  basePrice,
  adjustedUnitPrice,
  extPrice,
  adjustedExtPrice,
  discount,
  t,
  isUnit = false, 
}) => (
  <div>
    <div
      style={{
        textDecoration: isUnit ? (adjustedUnitPrice && 'line-through') : (adjustedExtPrice && 'line-through'),
        color: isUnit ? (adjustedUnitPrice && '#E5047E') : (adjustedExtPrice && '#E5047E'),
      }}
    >
      {isUnit
        ? basePrice
        : extPrice}
    </div>
    {(isUnit ? adjustedUnitPrice : adjustedExtPrice) && (
      <div>
        {isUnit
          ? adjustedUnitPrice
          : adjustedExtPrice}
      </div>
    )}
    {!isUnit && discount && (
      <div
        style={{
          whiteSpace: 'nowrap',
          marginLeft:
            Math.abs(discount).toString().length === 1
              ? '-27%'
              : Math.abs(discount).toString().length === 2
                ? '-31%'
                : '-44%',
          color: '#E5047E',
        }}
      >
        {`${discount}${t('equity.common.feesAndItems.discount')}`}
      </div>
    )}
  </div>
);

export default PriceCell;